module.exports = __webpack_public_path__ + "img/logo.75d20ff1.png";